/**
 * response from search-api-gateway /suggest endpoint
 */
export type TSuggestResultSearchApi = {
  suggestions: {
    text: string
    suggest_type: ESuggestTypeSearcApi
    base_product_no?: string
    category_path?: string
  }[]
}

export const enum ESuggestTypeSearcApi {
  BRAND = 'BRAND',
  CATEGORY = 'CATEGORY',
  PRODUCT_LINE = 'PRODUCT_LINE',
  SINGLE_PRODUCT = 'SINGLE_PRODUCT',
}
